import React from 'react';
import * as styledComponents from './styles'
import CellImage from 'media/CellComplete.png';
import { useHistory } from "react-router";
import VisibilitySensor from 'react-visibility-sensor';
import HeadphoneIcon from 'components/HeadphoneIcon';

const Home = React.forwardRef((props, ref) => {

  const history = useHistory();
  const changeVisibility = (isVisible) => {
    if (isVisible) {
      history.push('landing?section=home&type=scrolled')
    }
  }

  return (
    <VisibilitySensor partialVisibility onChange={changeVisibility}>
      <styledComponents.HomeContainer ref={ref}>
        <styledComponents.CellImageUp src={CellImage} />
        <styledComponents.FirstText>WORK WITH OUR TEAM AND HAVE</styledComponents.FirstText>
        <styledComponents.MainText>ALL OF WHAT YOUR STARTUP NEEDS IN ONE SINGLE PLACE</styledComponents.MainText>
        <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>FREE CONSULTATION<HeadphoneIcon /></styledComponents.CallToAction>
        <styledComponents.CellImageDown src={CellImage} />
      </styledComponents.HomeContainer>
    </VisibilitySensor>
  );
});

export default Home;